import React from 'react'
import {Flex} from '/app/src/component'
import FeatureItem from './FeatureItem'

const otherFeaturesStyle = {
    color: 'JibberPurple_M',
    marginTop: '22px'
}


const ProFeatures = () => {
    const color = 'JibberPurple_M'
    return (
        <Flex column>
            <Flex>
                <FeatureItem
                featureName='Helpdesk'
                color={color}
                imgSrc='/images/Menu_ClientChat_Helpdesk_L.svg'/>
                <FeatureItem
                featureName='Växelsystem'
                color={color}
                imgSrc='/images/Menu_SwitchSystem_L.svg'/>
                <FeatureItem
                featureName='Utökad statistik'
                color={color}
                imgSrc='/images/Menu_Overview_L.svg'/>
            </Flex>
            <Flex {...otherFeaturesStyle}>
                + Ökad datakapacitet och fler skräddarsydda inställningar.
            </Flex>
        </Flex>
    )
}

export default ProFeatures



// WEBPACK FOOTER //
// ./src/component/Modal/WelcomeModal/ProFeatures.js